import React from 'react';
import { Box, BoxProps } from '@material-ui/core';

export const Container: React.FC<BoxProps> = ( props ) => {
  return <Box m="auto" maxWidth={1480} { ...props } />;
}